import {
  Box,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { productBussiness } from "api/bussiness/product/product-bussiness";
import { ProductPermission } from "commons/enum/permission";
import { useCheckPermission } from "commons/hooks/use-check-permission";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { ChangeEventHandler, useCallback, useState } from "react";
import { UploadButton } from "share-components/mui-wrap/button/action-button";
import { FileList } from "./file-list";

interface FileError {
  code: "server" | "tooLarge";
  message?: string;
}

export const FileManager = observer(() => {
  const {
    productManagement: { productDetail, getProductDetail },
  } = useStores();
  const [fileError, setFileError] = useState<FileError | null>();
  const [uploading, setUploading] = useState<boolean>(false);
  const { allowAccess: allowUploadFile } = useCheckPermission([
    ProductPermission.UploadFile,
  ]);
  const theme = useTheme();
  function isFileTooLarge(file: File, maxSizeMB: number = 15): boolean {
    const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert MB to bytes
    return file.size > maxSizeBytes;
  }

  const fileChangedHandler: ChangeEventHandler<HTMLInputElement> = useCallback(
    async (e) => {
      try {
        setUploading(true);
        setFileError(null);
        const file = e.currentTarget.files?.[0];
        if (!file) {
          console.log("No files was found !");
          return;
        }

        if (isFileTooLarge(file)) {
          setFileError({
            code: "tooLarge",
            message: "Tệp phải nhỏ hơn 15Mb.",
          });
          return;
        }
        const formData = new FormData();
        formData.append(`file`, file);
        if (productDetail && productDetail.id) {
          await productBussiness.uploadFile(productDetail.id, formData);
          await getProductDetail(productDetail.id);
        }
      } catch (ex) {
      } finally {
        setUploading(false);
      }
    },
    [getProductDetail, productDetail]
  );
  return (
    <Stack direction={"column"} spacing={2}>
      <Stack direction={"row"} spacing={1} alignItems={"center"}>
        {allowUploadFile && (
          <UploadButton
            acceptFile=".pdf,.jpeg,.jpg"
            fileInputChanged={fileChangedHandler}
            disabled={uploading}
          ></UploadButton>
        )}

        {uploading ? (
          <Box>
            <CircularProgress size={"20px"}></CircularProgress>
          </Box>
        ) : (
          <></>
        )}
        {fileError ? (
          <Typography variant="body1" color={theme.palette.error.main}>
            {fileError.message}
          </Typography>
        ) : (
          <></>
        )}
      </Stack>
      <Stack>
        <FileList></FileList>
      </Stack>
    </Stack>
  );
});
